import FC from "./scheduler.global.js";
import * as i18n from "../../i18n.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as Html from "../../util/Html.ts";
import $ from '../../$.js'
import TPL_UNLOCK from '../../modal/unlock_blur.mustache'

export type ViewType = "day"|"timeGridWeek"|"dayGridMonth"|"listYear"|"resourceTimeGridDay"
export type ResourceApi = {id:string,title:string}
export type selectionInfo = {
  allDay :boolean, 
  end :Date, 
  start:Date, 
  view : any, 
  resource ?:ResourceApi,
  oldResource ?:ResourceApi,
}
export type ViewImpl = {
  type: ViewType
}

    
export class CalendarFamilyWall extends FC.Calendar{
  node:HTMLElement;
  constructor(node :HTMLElement,options){
    super(node,Object.assign({
      allDayText: i18n.get('new_event.allday'),
      weekText: i18n.get('weekLetter'),
      schedulerLicenseKey:"0747743404-fcs-1742482395"
    },options))
    this.node = node
    this.handlePremium(options.initialView)  
  }
  changeView(view :string){
    super.changeView(view)
    this.handlePremium(view)  
  }
  handlePremium(view :string){
    //if no state it means it is a shared by url calendar
    const blur = !(FwDatas.getState()?.premium.audio) && view==='resourceTimeGridDay';
    if(blur){
      this.node.style.filter = 'blur(4px)'
      this.node.style.pointerEvents = 'none'
      Html.setHtmlAtEnd($(this.node.parentNode),TPL_UNLOCK,{
        h2:'calendarmember.unlocktitle',
        mediaSize:'120',
        image:'/images/locked_state_member_view.svg',
        message:'calendarmember.unlocktext',
        button:[{title:'calendarmember.unlockbutton',class:"premium",action:'takepremium'}]
      })
    }else{
      this.node.style.filter = ''
      this.node.style.pointerEvents = ''
      $('.blur-veil').remove()
    }

  }
  
}
export {CalendarFamilyWall as Calendar}
document.head.insertAdjacentHTML('beforeend',`<style>
.fc {
  height:100%;
  font-size:14px;
  line-height:1em;
  position:relative;
  z-index:0;
  --fc-today-bg-color:#80808008;
  --fc-list-event-hover-bg-color:var(--bg-selected);
  --fc-neutral-bg-color:var(--fwBackground);
}

.fc .fc-daygrid-day-number {
  height:1.5em;width:1.5em;text-align:center;line-height:1.5em;padding:0px;margin:1px;
}
.fc .fc-day-today .fc-daygrid-day-number {
  background:var(--brand-color);border-radius: 50%;color: white;
}
.fc .fc-col-header-cell-cushion {
  padding-top:16px;
  padding-bottom:16px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  max-width: 100%;
} 
.fc-event-title {
  font-weight:bold;
  user-select:none;
}
@media only print{
  .fc * {
    color:#000;
  }
}
</style>`);


